/* eslint-disable */

// export const ApiUrl = "http://127.0.0.1:5000/";
export const ApiUrl = "https://api-source.boo9.com/";
